// "A new version is available" support. Every build writes /version.json ({"build": "<id>"}) and compiles the same id into the
// bundle (VUE_APP_BUILD_ID, see vue.config.js). An open or cached page compares the two and App.vue offers a reload when they
// differ, so nobody keeps running yesterday's code against today's API (the usual reason why "it works in a private window").

export const NEW_VERSION_EVENT = "camceadhub:new-version";
const CHECK_EVERY_MS = 10 * 60 * 1000;

// Pure, testable: is the build the server reports a different one from the one running here?
export function isNewBuild(localBuild, remote) {
  if (!localBuild || localBuild === "dev") return false; // dev server / unknown: never nag
  const remoteBuild = remote && typeof remote.build === "string" ? remote.build : "";
  return remoteBuild !== "" && remoteBuild !== localBuild;
}

export async function checkForNewVersion(fetchFn = fetch, localBuild = process.env.VUE_APP_BUILD_ID) {
  try {
    const res = await fetchFn(`/version.json?t=${Date.now()}`, { cache: "no-store", credentials: "omit" });
    if (!res.ok) return false;
    const data = await res.json(); // an SPA fallback returns index.html here: json() throws, nothing is reported
    return isNewBuild(localBuild, data);
  } catch (e) {
    return false;
  }
}

let started = false;
export function startVersionWatch() {
  if (started || typeof window === "undefined") return;
  started = true;
  const run = async () => {
    if (await checkForNewVersion()) {
      window.dispatchEvent(new CustomEvent(NEW_VERSION_EVENT));
    }
  };
  setInterval(run, CHECK_EVERY_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") run();
  });
  setTimeout(run, 15000);
}
